import React from 'react';

export interface SidebarState {
  isCollapsed: boolean;
  toggleSidebar: () => void;
}

export const SidebarContext = React.createContext<SidebarState>({
  isCollapsed: false,
  toggleSidebar: () => { },
});
